module.exports = __webpack_public_path__ + "img/chuang3.85f2a2ce.png";